export default __webpack_public_path__ + "static/parents-hero-dd6190b2272e674939037e2ef2e0cd73.jpg";